import { render, staticRenderFns } from "./Indivual.vue?vue&type=template&id=23b7eb04&"
import script from "./Indivual.vue?vue&type=script&lang=js&"
export * from "./Indivual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports